import { AnalyticsService } from '@alison/analytics/client';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { signOut, useSession } from './authClient.js';
import { clearSelectionCookie } from './cookies.js';

interface AuthenticatedSession {
  session: ReturnType<typeof useSession>['data'];
  isPending: boolean;
  onSignOut: () => Promise<void>;
}

export function useAuthenticatedSession(): AuthenticatedSession {
  const navigate = useNavigate();
  const { data: session, isPending } = useSession();

  useEffect(() => {
    if (!isPending && session === null) {
      void navigate({ to: '/login' });
    }
  }, [isPending, session, navigate]);

  async function onSignOut(): Promise<void> {
    AnalyticsService.track('Auth - Logout');
    AnalyticsService.logout();
    clearSelectionCookie();
    await signOut();
    await navigate({ to: '/login' });
  }

  return { session, isPending, onSignOut };
}
